import VideoCardFooter from './VideoCardFooter';

export default VideoCardFooter;
